import { IDateTimeWithZone } from "../common/date-time-with-zone.interface";
import { IJobLevelInfo } from "./job-level.interface";
import { IJobTitleInfo } from "./job-title.interface";
import { IRiskInfo } from "./risk-info.interface";
import { ICompanyEngagementHistory } from "./company-engagement-history.interface";
import { DateTimeWithZone } from "../common/date-time-with-zone.class";
import { DegreeOfSupervisionString, RiskMatrixLevel } from "./risk-matrix-level.enum";
import { EmploymentStatus } from './employment-status.class';
import { consts } from '../common/modals/consts';
import { RiskInfo } from './risk-info.class';
import { JobTitleInfo } from './job-title.class';
import { JobLevelInfo } from './job-level.class';
import { OperativeTypeInfo } from "./operative-type.class";
import { IOperativeTypeInfo } from "./operative-type.interface";
import { IBusinessUnitInfo } from "./business-unit.interface";
import { BusinessUnitInfo } from "./business-unit.class";

export class CompanyEngagementHistory implements ICompanyEngagementHistory {
  id: string;
  companyId: string;
  operativeId: string;
  from: IDateTimeWithZone;
  to: IDateTimeWithZone;
  jobLevel: JobLevelInfo;
  jobLevelId: string;
  jobTitle: JobTitleInfo;
  jobTitleId: string;
  risk: RiskInfo;
  riskId: string;
  riskMatrixLevel: RiskMatrixLevel;
  employmentStatusId: string;
  employmentStatus: EmploymentStatus;
  supervisionString: string;
  operativeTypeId: string;
  operativeType: OperativeTypeInfo;
  businessUnitId: string;
  businessUnit: BusinessUnitInfo;

  constructor(iCompanyEngagementHistory?: ICompanyEngagementHistory) {
    this.id = iCompanyEngagementHistory?.id;
    this.companyId = iCompanyEngagementHistory?.companyId;
    this.operativeId = iCompanyEngagementHistory?.operativeId;
    this.from = new DateTimeWithZone(iCompanyEngagementHistory?.from);
    this.to = new DateTimeWithZone(iCompanyEngagementHistory?.to);
    this.jobLevelId = iCompanyEngagementHistory?.jobLevelId;
    this.jobTitleId = iCompanyEngagementHistory?.jobTitleId;
    this.riskId = iCompanyEngagementHistory?.riskId;
    this.riskMatrixLevel = iCompanyEngagementHistory?.riskMatrixLevel;
    this.employmentStatusId = iCompanyEngagementHistory?.employmentStatusId || consts.emptyGuid;
    this.employmentStatus = new EmploymentStatus(iCompanyEngagementHistory?.employmentStatus);
    this.supervisionString = iCompanyEngagementHistory?.supervisionString || '';
    this.jobLevel = new JobLevelInfo(iCompanyEngagementHistory?.jobLevel as IJobLevelInfo) || new JobLevelInfo({} as IJobLevelInfo);
    this.jobTitle = new JobTitleInfo(iCompanyEngagementHistory?.jobTitle as IJobTitleInfo) || new JobTitleInfo({} as IJobTitleInfo);
    this.risk = new RiskInfo(iCompanyEngagementHistory?.risk) || new RiskInfo({} as IRiskInfo);
    this.operativeTypeId = iCompanyEngagementHistory?.operativeTypeId;
    this.operativeType = new OperativeTypeInfo(iCompanyEngagementHistory?.operativeType as IOperativeTypeInfo) || new OperativeTypeInfo({} as IOperativeTypeInfo);
    this.businessUnitId = iCompanyEngagementHistory?.businessUnitId;
    this.businessUnit = new BusinessUnitInfo(iCompanyEngagementHistory?.businessUnit as IBusinessUnitInfo) || new BusinessUnitInfo({} as IBusinessUnitInfo);
  }

  get isValid(): boolean {
    return !!this.jobLevelId && !!this.jobTitleId && !!this.riskId && !!this.from?.dateTime && !!this.employmentStatusId && !!this.operativeTypeId;
  }

}
